// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__yvztr","label":"Completed_label__2Eax6"};